import { Component, OnInit, ElementRef, ViewChild, Input, Renderer2, ChangeDetectionStrategy } from '@angular/core';
import { MatChipInputEvent } from '@angular/material/chips';
import { MatAutocompleteSelectedEvent, MatAutocomplete, MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { startWith, map, filter } from 'rxjs/operators';
import { typeDHLFormControls } from '../../models/dhl-form-shared-types';
import { AlphaService } from 'src/app/app-business-object-module/alpha.service';
import { AppService } from 'src/app/app.service';
import { APP_Constants } from 'src/app/app.constant';
import { ModalConfigData } from 'src/app/common/modalconfig/modalconfig';
import { ModalService } from 'src/app/common/modal/modal.service';
import { Modal } from 'src/app/common/modal/modal';

@Component({
    selector: 'app-form-field-chips-autocomplete',
    templateUrl: './form-field-chips-autocomplete.component.html',
    styleUrls: ['./form-field-chips-autocomplete.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FormFieldChipsAutocompleteComponent implements OnInit {

  validationType: string = '';
  // @Input() configData: typeDHLFormControls;
  @Input() configData: any;
  @Input() frmGroup: UntypedFormGroup;

  @ViewChild('searcOptionInput', {static: false, read: ElementRef}) searcOptionInput: ElementRef<HTMLInputElement>;
  @ViewChild('auto', {static: true, read: MatAutocomplete}) matAutocomplete: MatAutocomplete;
  @ViewChild(MatAutocompleteTrigger, {static: false, read: MatAutocompleteTrigger}) trigger: MatAutocompleteTrigger;

  visible = true;
  selectable = false;
  color: String = 'warn';
  mode: String = 'indeterminate';
  removable = true;
  separatorKeysCodes: number[] = [];
  searcOptionCtrl = new UntypedFormControl([]);
  filteredOptions: Observable<{}[]>;
  appearance= "outline";
  options = []
  allOptions = [];
  editField: boolean;
  isLoading: boolean;
  templateData: any;
  selfServiceConfig: boolean = false;
  //  [{ disValue: "Lemon", value: 'Lemon' }];
  disabled: boolean = false;
  orderFormSubmitted;
  orderForm: any;


  constructor(private renderer: Renderer2, private alphaService: AlphaService,private apiService: AppService,private modalService: ModalService) {
    this.filteredOptions = this.searcOptionCtrl.valueChanges.pipe(
      startWith(null),
      map((searchKey: any | null): {}[] => {
        let result = searchKey ? this._filter(searchKey) : this.allOptions.slice();
        return result;
      }));
  }

  get f() { return this.frmGroup.controls; }

  ngOnInit() {
    
    //Check Self service status 
    if (this.configData.customFormFlag) {
      this.selfServiceConfig = false;
    } else if (sessionStorage.getItem("isSelfServiceConfig")) {
      this.selfServiceConfig = true;
    } //END

    console.log(this.configData);
    if(this.configData.appearance!=null || this.configData.appearance !=undefined){
      this.appearance = this.configData.appearance;
    }
    else{
      this.appearance ="standard";
    }
    this.configData.validation.forEach(element => {
      if (element === "NoSpecialCharacter") {
        this.validationType = element;
        this.frmGroup.get(this.configData.name).setValidators(Validators.pattern(new RegExp('^((?![$<>?%&*#!~`]).)*$')));
      }
      if (element === 'hidden') {
        if (!(this.frmGroup.get(this.configData.name)['hidden'] === false)) {
          this.frmGroup.get(this.configData.name)['hidden'] = true;
        }
      }
    }, this);
    // setting default value
    this.setDefaultValue();

    const control = this.frmGroup.get(this.configData.name);
    control?.valueChanges?.subscribe(value => {
      if (!value || (Array.isArray(value) && value?.length === 0)) {
        this.clearChipsUI();
      }
    });
  }

  onFocus() {
    // this.trigger._onChange("");
    if(!this.trigger.panelOpen){
      this.trigger.openPanel();
    }
  }

  setDefaultValue() {
    let selectedChipsData = null;
    if(this.frmGroup.get(this.configData.name).value){
      selectedChipsData = this.frmGroup.get(this.configData.name).value.value || this.frmGroup.get(this.configData.name).value;
    }
    let chipsData = selectedChipsData || this.configData.defaultValue.value;

    if (chipsData) {
      this.configData.options.forEach((opt: any) => {
        // let selectedOpt = null;
        if (!Array.isArray(chipsData)){
          chipsData = chipsData.replaceAll("'", "").split(",");
        }
        let selectedOpt = chipsData.filter(defaultOpt => {
          if ((typeof defaultOpt == 'string' && opt.value == defaultOpt) || (opt.value == defaultOpt.value)) {
            return true;
          }
        });
        if (selectedOpt.length) {
          this.options.push(opt);
        } else {
          this.allOptions.push(opt);
        }
      })
      this.manageMultiAffectedColumn(this.options, '', true);
    } else {
      this.allOptions = this.configData.options.slice();
    }
    this.frmGroup.get(this.configData.name).setValue(chipsData);
    this.searcOptionCtrl.setValue(null);
    console.log(this.frmGroup.get(this.configData.name).value);
  }


  add(event: MatChipInputEvent): void {
    const value = event.value;
    // Add our fruit
    if ((value || '').trim()) {
      // this.fruits.push(value.trim());
    }
    // Reset the input value
    event.chipInput!.clear();
    this.searcOptionCtrl.setValue(null);
  }

  remove(removeOption: { value: string }, index): void {
    let removedOption = this.options?.[index];
    let splitArr = this.options.slice(index, index + 1);
    this.options.splice(index, 1);
    this.allOptions = splitArr.concat(this.allOptions);
    this.searcOptionCtrl.setValue(null);
    this.frmGroup.get(this.configData.name).setValue(this.options.map(opt => opt.value));
    this.manageMultiAffectedColumn(this.options, removedOption);
  }


  selected(event: MatAutocompleteSelectedEvent): void {
    this.options.push(event.option.value);
    this.searcOptionInput.nativeElement.value = '';
    for (let i = 0; i < this.allOptions.length; i++) {
      if (event.option.value.value == this.allOptions[i].value) {
        this.allOptions.splice(i, 1);
        break;
      }
    }
    this.searcOptionCtrl.setValue(null);
    this.frmGroup.get(this.configData.name).setValue(this.options.map(opt => opt.value));
    this.manageMultiAffectedColumn(this.options, event.option.value);
  }

  toggleVisibility(hidden = !this.frmGroup.get(this.configData.name)['hidden']){
    this.configData.required = !hidden; // if fied is visible, it will be mandatory because we loose initial required data
    this.frmGroup.get(this.configData.name)['hidden'] = hidden;
    if (hidden === true) {
      this.frmGroup.get(this.configData.name).reset();
      this.frmGroup.get(this.configData.name).updateValueAndValidity();
    }
    this.allOptions = this.allOptions.concat(this.options); 
    this.options=[]
    this.searcOptionCtrl.setValue(null);
    this.frmGroup.get(this.configData.name).setValue([]);
  }

  private _filter(option: any): {}[] {
    let filterValue = (typeof option !== "string" ? option.value : option).toLowerCase();
    return this.allOptions.filter((option: any) => option.displayValue.toLowerCase().indexOf(filterValue) === 0);
  }
  getPlaceholder(){
    if(this.configData && this.frmGroup && this.frmGroup.get(this.configData.name) && (this.configData.required || this.frmGroup.get(this.configData.name)['required'])){
      return `${this.configData.placeHolder} *`;
    }
    return `${this.configData.placeHolder}`;
  }

  ngAfterViewInit(){
    this.toggleDisable(this.configData['disabled']);
  }

  toggleDisable(disabled){
    if (disabled === true) {
      this.frmGroup.get(this.configData.name).disable();
      //this.formControl.nativeElement.parentElement.classList.add('disabled');
    } else {
      this.frmGroup.get(this.configData.name).enable();
      //this.formControl.nativeElement.parentElement.classList.remove('disabled');
    }
  }

  manageMultiAffectedColumn(data, latestSelection, keepAffectedColumnValues = false) {
    let isMatch = false, fieldCtrl, value;
    if(this.configData['multiAffectedColumns']) {
      this.configData['multiAffectedColumns'].forEach(element => {
        element.value.forEach(field => {
          isMatch = this.alphaService.compareValues(element.key, data);
          fieldCtrl = this.frmGroup?.get(field?.name);
          value = this.frmGroup?.get(field?.name)?.value;
          if (field.action === "SHOW" && isMatch && fieldCtrl) {
            if(field?.reset && !keepAffectedColumnValues && this.alphaService.isBlank(value)) this.alphaService.isReset(field, this.frmGroup);
            this.frmGroup.get(field.name)['hidden'] = false;
            this.alphaService.isRequired(field, this.frmGroup);
          } else if (field.action === "HIDE" && isMatch && fieldCtrl && element?.key[0] === latestSelection?.value) {
            if(field.reset && !keepAffectedColumnValues) this.alphaService.isReset(field, this.frmGroup);
            this.frmGroup.get(field.name)['required'] = false;
            this.frmGroup.get(field.name)['hidden'] = true;
            this.frmGroup.get(field.name).removeValidators([Validators.required]);
          } else if (field.action === "DEPENDENT_FIELD" && fieldCtrl && this.alphaService.compareValues(element.key, this.frmGroup.get(field.dependentFieldName).value)) {
            if(field.reset) this.alphaService.isReset(field, this.frmGroup);
            this.alphaService.isRequired(field, this.frmGroup);
          } else if (field.action === "SETDATA" && isMatch && fieldCtrl) {
            this.frmGroup.get(field.name)["hidden"] = false;
            if (field.required) this.alphaService.isRequired(field, this.frmGroup);
            if (field?.defaultValue && this.alphaService.isBlank(value)) this.frmGroup.get(field.name).setValue(field.defaultValue);
          } else if (field.action !== "DEPENDENT_FIELD" && fieldCtrl && element?.key[0] === latestSelection?.value) {
            if(field?.reset && !keepAffectedColumnValues) this.alphaService.isReset(field, this.frmGroup);
            this.frmGroup.get(field.name)['required'] = false;
            this.frmGroup.get(field.name)['hidden'] = true;
            this.frmGroup.get(field.name).removeValidators([Validators.required]);
          }
          this.frmGroup?.get(field.name)?.updateValueAndValidity();
        })
      })
    }
  }

  setDefaultValueOnReset() {
    let selectedChipsData = null;
    if(this.frmGroup.get(this.configData.name).value){
      selectedChipsData = this.frmGroup.get(this.configData.name).value.value || this.frmGroup.get(this.configData.name).value;
    }
    let chipsData = selectedChipsData || this.configData.defaultValue.value;

    if (chipsData) {
      this.options.length = 0;
      this.configData.options.forEach((opt: any) => {

        let selectedOpt = chipsData.filter(defaultOpt => {
          if ((typeof defaultOpt == 'string' && opt.value == defaultOpt) || (opt.value == defaultOpt.value)) 
            return true;  
        });
   
        if(selectedOpt.length && !this.alphaService.compareValues(selectedOpt, this.options)) {
          this.options.push(opt);
          for (let i = 0; i < this.allOptions.length; i++) {
            if (selectedOpt == this.allOptions[i].value) {
              this.allOptions.splice(i, 1);
              break;
            }
          }
        } else if(!this.alphaService.compareValues(opt?.value, this.allOptions)) {
          this.allOptions.push(opt);
        }
      })
    } else {
      this.allOptions = this.configData.options.slice();
    }
    this.searcOptionCtrl.setValue(null);
    this.allOptions = this.allOptions.sort((a, b) => {
      return this.configData.options.indexOf(a) - this.configData.options.indexOf(b);
    });
    this.manageMultiAffectedColumn(this.options, '');
  }

  closePanel(event: FocusEvent) {
    const relatedTarget = event.relatedTarget as HTMLElement;
    if (!relatedTarget || !relatedTarget.classList.contains('mat-option')) {
      this.trigger.closePanel();
    }
  }

  clearChipsUI() {
    this.options = [];
    this.searcOptionCtrl.setValue('');
    this.allOptions = [...this.configData.options]; // keep one permanent copy
    this.filteredOptions = this.searcOptionCtrl.valueChanges.pipe(
      startWith(null),
      map((search: string | null) => search ? this._filter(search) : this.allOptions.slice())
    );
  }
}
